<template>
    <div style="width: 1200px;margin: 0 auto;">
      <div class="crumbs">
        <span style="cursor: pointer;" @click="Jump({path:'/'})">{{ $t('view.首页') }}</span><span style="margin: 0 5px">></span>
        <span>{{ $t('view.工作台') }}</span><span style="margin: 0 5px">></span>
        <span>{{ $t('view.个人中心') }}</span><span style="margin: 0 5px;color: #333333;">></span>
        <span @click="Jump(item)" style="cursor: pointer;color: #333333;" v-for="(item,index) in $route.meta.urlName" :key="item.path">
          <span :style="{color:index<$route.meta.urlName.length-1?'#999999':'#333333'}">{{ item.name }}</span><span style="margin: 0 5px;color: #333333;" v-if="index<$route.meta.urlName.length-1">></span>
        </span>
      </div>

      <div style="display: flex;">
          <div class="left">
              <div style="color: #333333;font-weight: 600;">{{$t('view.个人中心') }}</div>
              <div style="position: relative;" @click="Jump(item)" :class="[item.path==$route.meta.identifying?'ChoseTitle':'']" v-for="item in list" :key="item.path">
                <span class="num" v-if="item.num">{{ item.num }}</span>
                {{ item.title }}
              </div>
          </div>
          <div style="flex: 1;">
              <router-view />
          </div>
      </div>
    </div>
  </template>
    
<script>
import {authorizationVerify,getToDetailQuoted} from '@/api/project'
import {clientList,countMaterialPartPending} from '@/api/PersonalCenter'
import eventBus from '@/utils/eventBus.js' 

  export default {
    data(){
        return{
            list:[
                {title:this.$t('view.我的投标'),path:'MyBid',num:''},
                {title:this.$t('view.企业信息'),path:'EnterpriseCertificationDet'},
                // {title:this.$t('view.企业认证'),path:'CompanyQualification'},
                {title:this.$t('view.个人信息'),path:'PersonalInformation'},
                {title:this.$t('view.授权委托书管理'),path:'PowerOfAttorney'},
                {title:this.$t('view.密码修改'),path:'PasswordModification'},
                {title:this.$t('view.我的问题'),path:'MyQuestion'},
                {title:this.$t('view.我的关注'),path:'MyFollowing'},
                {title:this.$t('view.处理事项'),path:'HandlingMatters',num:''},
                {title:this.$t('view.备件信息完善'),path:'SpareParts',num:''},
            ]
        }
    },
    created(){
      if(this.$store.getters.name){
        this.authorizationVerify()
        this.clientList()
      }

      eventBus.$on('HandlingMattersNum',(message)=>{ 
          this.list.map(item=>{
            if(item.path == 'HandlingMatters'){
              item.num = message
            }
          }) 
      })
    },
    methods:{
      // 处理事项的数量
      clientList(){
        getToDetailQuoted().then(res=>{
          this.list.map(item=>{
            if(item.path == 'MyBid'){
              item.num = res.data
            }
          })
        })
        countMaterialPartPending().then(res=>{
          if(res.data){
            this.list.map(item=>{
              if(item.path == 'SpareParts'){
                item.num = res.data
              }
            })
          }
        })
        clientList({statusList:[0,4]}).then(res=>{
          if(res.total>0)
              this.list.map(item=>{
                if(item.path == 'HandlingMatters'){
                  item.num = res.total
                }
              })
          })
      },
      authorizationVerify(){
        authorizationVerify().then(res=>{
          
          if(res.data.operationUserType==1){
            this.list=this.list.filter(obj => obj.path !== 'EnterpriseCertification');  
          }
        })
      },
        Jump(item){
            if(item.path==this.$route.name)
            return
            this.$router.push(item.path) 
        }
    }
  };
  </script>
  <style lang="scss" scoped>
  .left{
    width: 125px;
    text-align: center;
    padding: 10px 0;
    cursor: pointer;
    line-height: 35px;
    font-size: 14px;
    color: #999999;
    background: #fff;
    height: 60vh;
    margin-right: 20px;
  }
  .ChoseTitle{
    color:  $mainBody-color;
  }
  .crumbs{
    font-size: 16px;
    line-height: 35px;
    span{
      color: #999999;
    }
  }
  .num{
    display: inline-block;
    height: 18px;
    padding: 0 2px;
    background: #E02020;
    border-radius: 7px 7px 7px 2px;
    color: white;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
    position: absolute;
    right: 25px;    
    top: 0;
    cursor: pointer;
    transform: translateX(50%);
  }
  </style>
   